import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const ErrorMessage = ({ message, onRetry, retryLabel = 'Tentar novamente' }) => {
    return (_jsxs("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            gap: '1rem',
            padding: '2rem',
            textAlign: 'center',
        }, children: [_jsx("div", { style: {
                    fontSize: '48px',
                    color: '#e74c3c',
                    marginBottom: '1rem',
                }, children: "\u26A0\uFE0F" }), _jsx("div", { style: {
                    color: '#e74c3c',
                    fontSize: '18px',
                    marginBottom: '1rem',
                    maxWidth: '400px',
                }, children: message }), onRetry && (_jsx("button", { onClick: onRetry, style: {
                    padding: '12px 24px',
                    backgroundColor: '#3498db',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '16px',
                }, children: retryLabel }))] }));
};
